import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Redirect, Route } from "react-router";
import { useAppSelector } from "../hooks/hooks";
export const PrivateRoute = ({ children, path, }) => {
    const isAuthenticated = useAppSelector((state) => state.user.isAuthenticated);
    return _jsx(Route, Object.assign({ path: path }, { children: isAuthenticated ? children : _jsx(Redirect, { to: "/login" }) }));
};
